export default "__VITE_ASSET__DxrNIibx__"